import { getTaskDetails, getTaskReserveUsers } from 'features/projectsSlice'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { projectService } from 'services/projectsService'
import { CUSTOM_ERROR_CODES } from 'utils/config'
import { handleErrorMessage } from 'utils/helpers'

const useAssignUserManual = ({ projectId, taskId, setInnerLoading }) => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const [addCustomUser, setAddCustomUser] = useState(false)
  const [forcedMode, setForcedMode] = useState(false)

  const handleAssignProjectTaskUser = (userId) => {
    setInnerLoading(true)
    projectService
      .adminAssignProjectTaskUser({ projectId, taskId, userId, force: Boolean(forcedMode) || null })
      .then(() => {
        enqueueSnackbar('Użytkownik został przypisany.', { variant: 'success' })
        setAddCustomUser(false)
        dispatch(getTaskDetails({ projectId, taskId }))
        dispatch(getTaskReserveUsers({ projectId, taskId }))
      })
      .catch((err) => {
        if (err.response?.data?.errorCode === CUSTOM_ERROR_CODES.TASK_ALREADY_ASSIGNED_SAME_DAY) {
          setForcedMode(err.response.data.errorCode)
          enqueueSnackbar('Kolejna próba przypisania zignoruje ograniczenie jednego zadania dziennie.', {
            variant: 'info',
            autoHideDuration: 10000,
          })
        }
        if (err.response?.data?.errorCode === CUSTOM_ERROR_CODES.BILLING_INFO_INCOMPLETE) {
          setForcedMode(err.response.data.errorCode)
          enqueueSnackbar('Kolejna próba przypisania zignoruje ograniczenie braku uzupełnienia danych do umowy.', {
            variant: 'info',
            autoHideDuration: 10000,
          })
        }
        enqueueSnackbar(handleErrorMessage(err, 'Coś poszło nie tak.'), { variant: 'error', autoHideDuration: 10000 })
      })
      .finally(() => setInnerLoading(false))
  }

  return {
    addCustomUser,
    setAddCustomUser,
    forcedMode,
    setForcedMode,
    handleAssignProjectTaskUser,
  }
}

export default useAssignUserManual
